import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';
import {_CALLS_STORE, MUTATIONS} from '../values/calls.values';
import log from 'js-logger';

export const CALLS_STORE = _CALLS_STORE;

@Module({ namespaced: true })
export class CallsStore extends VuexModule {

  public isOnCall: boolean = false;
  public callConf: any = {};
  public isMuted: boolean = false;
  public deviceInfo: any = {};
  public sip: any = {};
  public agent: any = {};
  public meet: any = {};

  public audioSrc: any;
  public audioSrcId: string;

  public audioOutput: any;
  public audioOutputId: string;

  public videoSrc: any;
  public videoSrcId: string;

  public processing: boolean = false;

  public localTime: string = '';

  @Mutation
  public cleanCall() : void {
    this.isOnCall = false;
    this.callConf = {};
    this.isMuted = false;
    this.deviceInfo = {};
    this.sip = {};
    this.audioSrc = null;
    this.audioOutput = null;
    this.videoSrc = null;
    this.audioSrcId = null;
    this.audioOutputId = null;
    this.videoSrcId = null;
    this.meet = {};
    this.agent = {};
  }


  @Mutation
  public updateLocalTime(localTime:string) : void {
    this.localTime = localTime;
  }

  @Mutation
  public updateProcessing(processing:boolean) : void {
    this.processing = processing;
  }

  @Mutation
  public updateIsOnCall({isOnCall}:{isOnCall:boolean}) : void {
    this.isOnCall = isOnCall;
  }

  @Mutation
  public updateCallConf(conf:any) : void {
    this.callConf = conf;
  }

  @Mutation
  public updateMicMuted(isMuted:boolean) : void {
    this.isMuted = isMuted;
  }

  @Mutation
  public updateDeviceInfo(devInfo:any) : void {
    this.deviceInfo = devInfo;
  }

  @Mutation
  public updateSip(sipTmp:any) : void {
    this.sip = Object.assign(this.sip, sipTmp);
  }

  @Mutation
  public updateMeet(meet:any) : void {
    this.meet = Object.assign(this.meet, meet);
  }

  @Mutation
  public setMeet(meet:any) : void {
    this.meet = meet;
  }

  @Mutation
  public updateAudioSrc(audioSrc:any) : void {
    this.audioSrc = audioSrc;
    if (this.audioSrc){
      this.audioSrcId = audioSrc.deviceId;
    }else{
      this.audioSrcId = null;
    }
  }

  @Mutation
  public updateAudioOutput(audioOutput:any) : void {
    this.audioOutput = audioOutput;
    if (this.audioOutput){
      this.audioOutputId = audioOutput.deviceId;
    }else{
      this.audioOutputId = null;
    }

  }

  @Mutation
  public updateVideoSrc(videoSrc:any) : void {
    this.videoSrc = videoSrc;
    if (this.videoSrc){
      this.videoSrcId = videoSrc.deviceId;
    }else{
      this.videoSrcId = null;
    }
  }

  @Mutation
  public muteLocal(local:any) : void {
    const found = this.meet.members.find(m=>m.id === local.participantId);
    const others = this.meet.members.filter(m=>m.id !== local.participantId);
    let lm = others;
    found.muted = local.muted;
    lm.push(found);
    let obj = {};
    obj['members'] = lm;
    this.meet = Object.assign(this.meet, obj);
  }

  @Mutation
  public updateAgent(agent:any) : void {
    if (Object.keys(this.agent).length === 0){
      log.error('LEGO [state updateAgent] Empty Agent: ', agent);
      return;
    }

    switch (agent.prop) {
      case 'registering': {
        this.agent.registering = agent.value;
        break;
      }
      case 'isReRegister': {
        this.agent.isReRegister = agent.value;
        break;
      }
      case 'registrationCompleted': {
        this.agent.registrationCompleted = agent.value;
        break;
      }
      case 'transport.attemptingReconnection': {
        this.agent.transport.attemptingReconnection = agent.value;
        break;
      }
      case 'transport.ReconnectionAttempts': {
        this.agent.transport.ReconnectionAttempts = agent.value;
        break;
      }
      default: {
        log.error('LEGO [state updateAgent] key not found!!!  ', agent);
      }
    }
  }

  @Mutation
  public setAgent(agent:any) : void {
    this.agent = agent;
  }
  //--------------------------------------------------------------------------------------------------------------------

  @Action({})
  public updateAgentA(data: any) : Promise<void> {
    return new Promise((resolve) => {
      log.info('LEGO [updateAgent] Action: ',data);
      this.context.commit(MUTATIONS.UPDATE_AGENT, data);
      resolve();
    });
  }

  @Action({})
  public setAgentA(data: any) : Promise<void> {
    return new Promise((resolve) => {
      log.info('LEGO [setAgentA] Action: ',data);
      this.context.commit(MUTATIONS.SET_AGENT,data);
      resolve();
    });
  }

  /* Initial State */
  @Mutation
  public initState(state) {
    this.isOnCall = false;
    this.callConf = {};
    this.isMuted = false;
    this.deviceInfo = {};
    this.sip = {};
    this.audioSrc = null;
    this.audioOutput = null;
    this.videoSrc = null;
    this.audioSrcId = null;
    this.audioOutputId = null;
    this.videoSrcId = null;
    this.meet = {};
    this.agent = {};
  }
}
